import React from "react";
import {useState,useEffect} from "react";
import {useLocation,useNavigate} from "react-router-dom";
import Grid from "@mui/material/Grid";
import LinearProgress from "@mui/material/LinearProgress";
import {Box} from "@mui/system";
import {Button} from "primereact/button";
import {InputText} from "primereact/inputtext";
import {Dialog} from "primereact/dialog";
import {confirmDialog} from "primereact/confirmdialog";
import {ConfirmDialog} from "primereact/confirmdialog";
import {BlockUI} from "primereact/blockui";
import {DataTable} from "primereact/datatable";
import {Column} from "primereact/column";
import {Dropdown} from "primereact/dropdown";
import Message from "../Helpers/Message.js";
import {fetch_url_post} from "../../Sources/js/app.js";

let oper="";

let defaultInputValues={
	id: null,
	product_type_id: 0,
	name: "",
	code: "",
	product_mu_id: 0,
	observations: "",
	filter_products: "",
	filter_by_type: "",
	vat_level: 0.21,
};

let defaultInputValuesTypes={
	id: null,
	name: "",
};

let defaultInputValuesMUs={
	id: null,
	name: "",
	abbr: "",
};

let defaultDataValues={
	productsList: [],
	typesList: [],
	MUsList: [],
};

let defaultDialogValues={
	openAddEdit: false,
	titleAddEdit: "",
	openListTypes: false,
	titleListTypes: "",	
	openAddEditTypes: false,
	titleAddEditTypes: "",	
	openListMUs: false,
	titleListMUs: "",
	openAddEditMUs: false,
	titleAddEditMUs: "",
};

let defaultInputError={
	disableSave: false,
	errorText: "",
};

let defaultVATLevels=[
	{
		label: "0%",
		value : "0",
	},
	{
		label: "5%",
		value : "0.05",
	},
	{
		label: "9%",
		value : "0.09",
	},
	{
		label: "11%",
		value : "0.11",
	},
	{
		label: "21%",
		value : "0.21",
	}
];

let initialValue={};

const Products = (props) => {

	var timerId=null;
	defaultInputValues.id=(props.productId?props.productId:null);

	const [inputValues, setInputValues] = useState(defaultInputValues);
	const [dataValues, setDataValues] = useState(defaultDataValues);
	const [messageText, setMessageText] = useState(null);
	const [dataOk, setDataOk] = useState(false);
	const [dialogValues, setDialogValues] = useState(defaultDialogValues);
	const [inputError, setInputError] = useState(defaultInputError);	
	const [blockScreen, setBlockScreen] = useState(false);
	const [productsList, setProductsList] = useState([]);
	const [inputValuesTypes, setInputValuesTypes] = useState(defaultInputValuesTypes);
	const [inputValuesMUs, setInputValuesMUs] = useState(defaultInputValuesMUs);
	const [inputErrorTypes, setInputErrorTypes] = useState(defaultInputError);	
	const [inputErrorMUs, setInputErrorMUs] = useState(defaultInputError);	
	const [selectedElement, setSelectedElement] = useState({});
    const location = useLocation();
    const navigate = useNavigate();

	const handleChange = evt => {
		const {name, value} = evt.target;
		if(name==="name") {
			let found=false;
			if(dataValues.productsList.length>0) {
				dataValues.productsList.forEach(element => {
					if((value.toUpperCase()===element.name.toUpperCase())&&((value!==initialValue.name)||(!initialValue))) {
						found=true;
					}
				});
			}
			let tmp={
				disableSave: false,
				errorText: (found===true?"Exista deja un produs cu acest nume!":""),
			}
			setInputError(tmp);
		}
		if(name==="filter_products") {
			setProductsList(dataValues.productsList.filter((product)=>((product.name.toLowerCase().indexOf(value.toLowerCase())>-1))||(value==="")));
		}
		setInputValues({...inputValues,[name]:value});
	}

	const handleChangeTypes = evt => {
		const {name, value} = evt.target;
		if(name==="name") {
			let found=false;
			if(dataValues.typesList.length>0) {
				dataValues.typesList.forEach(element => {
					if((value.toUpperCase()===element.name.toUpperCase())&&((value!==initialValue.name)||(!initialValue))) {
						found=true;
					}
				});
			}
			let tmp={
				disableSave: found,
				errorText: (found===true?"Exista deja un tip cu acest nume!":""),
			}
			setInputErrorTypes(tmp);
		}
		setInputValuesTypes({...inputValuesTypes,[name]:value});
	}

	const handleChangeMUs = evt => {
		const {name, value} = evt.target;
		if(name==="name") {
			let found=false;
			if(dataValues.MUsList.length>0) {
				dataValues.MUsList.forEach(element => {
					if((value.toUpperCase()===element.name.toUpperCase())&&((value!==initialValue.name)||(!initialValue))) {
						found=true;
					}
				});
			}
			let tmp={
				disableSave: found,
				errorText: (found===true?"Exista deja o UM cu acest nume!":""),
			}
			setInputErrorMUs(tmp);
		}
		setInputValuesMUs({...inputValuesMUs,[name]:value});
	}

	const handleButton = (evt,what,elementData) => {
		if(what==="add") {
			setInputValues(defaultInputValues);
			setDialogValues({...dialogValues,openAddEdit: true,titleAddEdit: "Adaugare produs nou"});
			setInputError(defaultInputError);
		}
		if(what==="edit") {
			elementData.filter_products=inputValues.filter_products;
			setInputValues(elementData);
			initialValue=elementData;
			setDialogValues({...dialogValues,openAddEdit: true,titleAddEdit: "Editare produs "+elementData.name});
			setInputError(defaultInputError);
		}
		if(what==="delete") {
			let url="deleteProduct";
			url+="?session_id="+props.session.sessId;
			oper="delete";
			let data={
				id: elementData.id,
			};
			timerId=fetch_url_post(url,data,success_handler,fail_handler,wait_handler);
		}
		if(what==="save") {
			document.querySelectorAll("input").forEach((element)=>element.classList.remove("required_input_error"));
			if(inputValues.name==="") {
				setMessageText("Eroare: Completati campul nume!");				
				document.getElementById("name").classList.add("required_input_error");
				return false;
			}
			if(inputValues.mu==="") {
				setMessageText("Eroare: Completati campul unitate de masura!");				
				document.getElementById("mu").classList.add("required_input_error");
				return false;
			}
			if(inputValues.product_type_id==="") {
				setMessageText("Eroare: selectati tipul de produs!");				
				document.getElementById("product_type_id").classList.add("required_input_error");
				return false;
			}
			let url="saveProduct";
			url+="?session_id="+props.session.sessId;
			oper="save";
			let data={...inputValues};
			timerId=fetch_url_post(url,data,success_handler,fail_handler,wait_handler);
		}
		if(what==="list_types") {
			setDialogValues({...dialogValues,openListTypes: true,titleListTypes: "Lista tipuri de produs"});
		}
		if(what==="list_mus") {
			setDialogValues({...dialogValues,openListMUs: true,titleListMUs: "Lista unitati de masura de produs"});
		}
		if(what==="add_type") {
			setInputValuesTypes(defaultInputValuesTypes);
			setDialogValues({...dialogValues,openAddEditTypes: true,titleAddEditTypes: "Adaugare tip nou"});
			setInputErrorTypes(defaultInputError);
		}
		if(what==="edit_type") {
			setInputValuesTypes(elementData);
			initialValue=elementData;
			setDialogValues({...dialogValues,openAddEditTypes: true,titleAddEditTypes: "Editare "+elementData.name});
			setInputErrorTypes(defaultInputError);
		}
		if(what==="delete_type") {
			return false;
			let url="deleteProductType";
			url+="?session_id="+props.session.sessId;
			oper="delete_type";
			let data={
				id: elementData.id,
			};
			timerId=fetch_url_post(url,data,success_handler,fail_handler,wait_handler);
		}
		if(what==="save_type") {
			document.querySelectorAll("input").forEach((element)=>element.classList.remove("required_input_error"));
			if(inputValuesTypes.name==="") {
				setMessageText("Eroare: Completati campul nume!");				
				document.getElementById("type_name").classList.add("required_input_error");
				return false;
			}
			let url="saveProductType";
			url+="?session_id="+props.session.sessId;
			oper="save_type";
			let data={...inputValuesTypes};
			timerId=fetch_url_post(url,data,success_handler,fail_handler,wait_handler);
		}
		if(what==="add_mu") {
			setInputValuesMUs(defaultInputValuesTypes);
			setDialogValues({...dialogValues,openAddEditMUs: true,titleAddEditMUs: "Adaugare unitate de masura noua"});
			setInputErrorMUs(defaultInputError);
		}
		if(what==="edit_mu") {
			setInputValuesMUs(elementData);
			initialValue=elementData;
			setDialogValues({...dialogValues,openAddEditMUs: true,titleAddEditMUs: "Editare "+elementData.name});
			setInputErrorMUs(defaultInputError);
		}
		if(what==="delete_mu") {
			return false;
			let url="deleteProductMU";
			url+="?session_id="+props.session.sessId;
			oper="delete_mu";
			let data={
				id: elementData.id,
			};
			timerId=fetch_url_post(url,data,success_handler,fail_handler,wait_handler);
		}
		if(what==="save_mu") {
			document.querySelectorAll("input").forEach((element)=>element.classList.remove("required_input_error"));
			if(inputValuesMUs.name==="") {
				setMessageText("Eroare: Completati campul nume!");				
				document.getElementById("mu_name").classList.add("required_input_error");
				return false;
			}
			if(inputValuesMUs.abbr==="") {
				setMessageText("Eroare: Completati campul prescurtare!");				
				document.getElementById("abbr").classList.add("required_input_error");
				return false;
			}
			let url="saveProductMU";
			url+="?session_id="+props.session.sessId;
			oper="save_mu";
			let data={...inputValuesMUs};
			timerId=fetch_url_post(url,data,success_handler,fail_handler,wait_handler);
		}
	}

	const success_handler = (result) => {
		setBlockScreen(false);
		if(timerId) {
			clearTimeout(timerId);
			setMessageText("");
		}
		if(result.ok===0) {
			setMessageText("Eroare: "+result.error);
			return false;
		}
		if(result.is_auth===0) {
			navigate("/login");			
			return false;
		}
		if(result.message) {
			setMessageText(result.message);			
		}
		if((oper==="get")||(oper==="save")||(oper==="delete")||(oper==="save_type")||(oper==="delete_type")||(oper==="save_mu")||(oper==="delete_mu")) {
			if((oper==="get")||(oper==="save")||(oper==="delete")) {
				setDialogValues(defaultDialogValues);
			}
			if((oper==="get")||(oper==="save_type")||(oper==="delete_type")||(oper==="save_mu")||(oper==="delete_mu")) {
				setDataValues({...dataValues,productsList:(result.productsList?result.productsList:[]),
											typesList:(result.typesList?result.typesList:[]),						
											MUsList:(result.MUsList?result.MUsList:[])
				});
			}
			if((oper==="save")||(oper==="delete")) {
				setDataValues({...dataValues,productsList:(result.productsList?result.productsList:[])});
			}
			setProductsList(result.productsList?result.productsList.filter((product)=>((product.name.toLowerCase().indexOf(inputValues.filter_products.toLowerCase())>-1))||(inputValues.filter_products==="")):[]);
			if((oper==="save_type")||(oper==="delete_type")) {
				setDialogValues({...dialogValues,openAddEditTypes:false,titleAddEditTypes:""});
			}
			if((oper==="save_mu")||(oper==="delete_mu")) {
				setDialogValues({...dialogValues,openAddEditMUs:false,titleAddEditMUs:""});
			}
            if(!dataOk) {
                setDataOk(true);
            }
			oper="";
		}
	}

	const fail_handler = () => {
		setBlockScreen(false);
		if(timerId) {
			clearTimeout(timerId);
		}
		setMessageText("Eroare de conexiune. Va rugam sa incercati mai tarziu!");
	}

	const wait_handler = () => {
		setBlockScreen(true);
		setMessageText("Operatiunea este in curs...");
	}

	useEffect(() => {
		if(props.session.sessId) {
			oper="get";
			let url="getProducts";
			url+="?session_id="+props.session.sessId;
			let data={};
			fetch_url_post(url,data,success_handler,fail_handler);
		}else{
			navigate("/login");
		}
	},[props.session.sessId]);

	const addEditDialog = () => {
		return(
			<Dialog header={dialogValues.titleAddEdit} visible={true} onHide={(evt)=>setDialogValues({...dialogValues,openAddEdit:false})} className="responsive-dialog-med">
				<Grid container spacing={1} style={{"paddingTop":"12px"}}>
					<Grid item xs={12} sm={9} md={7} lg={8} className="field padding-min">
						<label htmlFor="name">Nume*</label>
						<InputText name="name" id="name" style={{"width":"100%"}} value={inputValues.name} onChange={(evt) => handleChange(evt)}/>
					</Grid>
					<Grid item xs={12} sm={3} md={3} lg={2} className="field padding-min">
						<label htmlFor="code">Cod</label>
						<InputText name="code" id="code" style={{"width":"100%"}} value={inputValues.code} onChange={(evt) => handleChange(evt)}/>
					</Grid>
					<Grid item xs={12} sm={9} md={2} lg={2} className="field padding-min">
						<label htmlFor="vat_level">Nivel TVA*</label>
						<Dropdown name="vat_level" id="vat_level" style={{"width":"100%"}} options={defaultVATLevels} value={inputValues.vat_level} onChange={(evt) => handleChange(evt)}/>
					</Grid>
					<Grid item xs={6} sm={6} md={6} lg={6} className="field padding-med">
						<label htmlFor="product_type_id">Tip produs*</label>
						<Dropdown name="product_type_id" id="product_type_id" style={{"width":"90%","float":"left"}} filter options={dataValues.typesList} optionLabel="name" optionValue="id" value={inputValues.product_type_id} onChange={(evt) => handleChange(evt)}/>
						<Button icon="pi pi-pencil" className="p-button-sm p-button-raised" style={{"width":"9.5%","float":"right"}} onClick={(evt) => handleButton(evt,"list_types")}/>
					</Grid>
					<Grid item xs={6} sm={6} md={6} lg={6} className="field padding-med">
						<label htmlFor="product_mu_id">Unitate de masura*</label>
						<Dropdown name="product_mu_id" id="product_mu_id" style={{"width":"90%","float":"left"}} options={dataValues.MUsList} filter value={inputValues.product_mu_id} optionLabel="name" optionValue="id" onChange={(evt) => handleChange(evt)}/>
						<Button icon="pi pi-pencil" className="p-button-sm p-button-raised" style={{"width":"9.5%","float":"right"}} onClick={(evt) => handleButton(evt,"list_mus")}/>
					</Grid>
					<Grid item xs={12} sm={12} md={12} lg={7} style={{"textAlign":"left","marginTop":"21px"}}>
						<div style={{"color":"#FF0000","fontWeight":"600","paddingTop":"0px"}}>
							{inputError.errorText}
						</div>
					</Grid>
					<Grid item xs={12} sm={12} md={12} lg={5} style={{"textAlign":"right","marginTop":"12px"}}>
						<Button label="Salveaza" icon="pi pi-check-circle" className="p-button-sm p-button-success p-button-raised" style={{"marginRight":"6px"}} onClick={(evt) => handleButton(evt,"save")} disabled={inputError.disableSave}/>
						<Button label="Inchide" icon="pi pi-times" className="p-button-sm p-button-danger p-button-raised" onClick={(evt)=>setDialogValues({...dialogValues,openAddEdit:false})}/>
					</Grid>
				</Grid>
			</Dialog>
		);
	}

	const listTypesDialog = () => {
		return(
			<Dialog header={dialogValues.titleListTypes} visible={true} onHide={(evt)=>setDialogValues({...dialogValues,openListTypes:false})} className="responsive-dialog-small">
				<div>
					<Grid container spacing={1} style={{}}>
						<Grid item xs={12} sm={12} md={12} lg={12} xl={12} className="field padding-med text-right">
							<Button label="Adauga tip nou" icon="pi pi-plus-circle" className="p-button-sm p-button-primary p-button-raised" style={{}} onClick={(evt) => {handleButton(evt,"add_type")}}/>
						</Grid>						
					</Grid>
					<DataTable
						value={dataValues.typesList}
						scrollable
						scrollHeight="60vh"
						style={{"minHeight":"63vh"}}
						scrollDirection="both"
						stripedRows
						resizableColumns
						columnResizeMode="fit"
						responsiveLayout="stack"
					>
						<Column field="name" header="Nume" style={{"flexGrow":"1","flexBasis":"180px"}} sortable></Column>
						<Column field="buttons" header="" style={{"flexGrow":"0","flexBasis":"90px"}} body={tableColTemplateTypes}></Column>
					</DataTable>
				</div>
			</Dialog>
		);
	}

	const listMUsDialog = () => {
		return(
			<Dialog header={dialogValues.titleListMUs} visible={true} onHide={(evt)=>setDialogValues({...dialogValues,openListMUs:false})} className="responsive-dialog-small">
				<div>
					<Grid container spacing={1} style={{}}>
						<Grid item xs={12} sm={12} md={12} lg={12} xl={12} className="field padding-med text-right">
							<Button label="Adauga UM noua" icon="pi pi-plus-circle" className="p-button-sm p-button-primary p-button-raised" style={{}} onClick={(evt) => {handleButton(evt,"add_mu")}}/>
						</Grid>						
					</Grid>
					<DataTable
						value={dataValues.MUsList}
						scrollable
						scrollHeight="60vh"
						style={{"minHeight":"63vh"}}
						scrollDirection="both"
						stripedRows
						resizableColumns
						columnResizeMode="fit"
						responsiveLayout="stack"
						selection={selectedElement}
					>
						<Column field="name" header="Nume" style={{"flexGrow":"1","flexBasis":"120px"}} sortable></Column>
						<Column field="abbr" header="Prescurtare" style={{"flexGrow":"1","flexBasis":"120px"}} sortable></Column>
						<Column field="buttons" header="" style={{"flexGrow":"0","flexBasis":"90px"}} body={tableColTemplateMUs}></Column>
					</DataTable>
				</div>
			</Dialog>
		);
	}

	const addEditTypesDialog = () => {
		return(
			<Dialog header={dialogValues.titleAddEditTypes} visible={true} onHide={(evt)=>setDialogValues({...dialogValues,openAddEditTypes:false})} className="responsive-dialog-small">
				<Grid container spacing={1} style={{"paddingTop":"12px"}}>
					<Grid item xs={12} sm={12} md={12} lg={12} className="field padding-min">
						<label htmlFor="name">Nume*</label>
						<InputText name="name" id="type_name" style={{"width":"100%"}} value={inputValuesTypes.name} onChange={(evt) => handleChangeTypes(evt)}/>
					</Grid>
					<Grid item xs={12} sm={12} md={12} lg={7} style={{"textAlign":"left","marginTop":"21px"}}>
						<div style={{"color":"#FF0000","fontWeight":"600","paddingTop":"0px"}}>
							{inputErrorTypes.errorText}
						</div>
					</Grid>
					<Grid item xs={12} sm={12} md={12} lg={5} style={{"textAlign":"right","marginTop":"12px"}}>
						<Button label="Salveaza" icon="pi pi-check-circle" className="p-button-sm p-button-success p-button-raised" style={{"marginRight":"6px"}} onClick={(evt) => handleButton(evt,"save_type")} disabled={inputErrorTypes.disableSave}/>
						<Button label="Inchide" icon="pi pi-times" className="p-button-sm p-button-danger p-button-raised" onClick={(evt)=>setDialogValues({...dialogValues,openAddEditTypes:false})}/>
					</Grid>
				</Grid>
			</Dialog>
		);
	}

	const addEditMUsDialog = () => {
		return(
			<Dialog header={dialogValues.titleAddEditMUs} visible={true} onHide={(evt)=>setDialogValues({...dialogValues,openAddEditMUs:false})} className="responsive-dialog-small">
				<Grid container spacing={1} style={{"paddingTop":"12px"}}>
					<Grid item xs={12} sm={12} md={8} lg={8} className="field padding-min">
						<label htmlFor="name">Nume*</label>
						<InputText name="name" id="mu_name" style={{"width":"100%"}} value={inputValuesMUs.name} onChange={(evt) => handleChangeMUs(evt)}/>
					</Grid>
					<Grid item xs={12} sm={12} md={4} lg={4} className="field padding-min">
						<label htmlFor="abbr">Prescurtare*</label>
						<InputText name="abbr" id="abbr" style={{"width":"100%"}} value={inputValuesMUs.abbr} onChange={(evt) => handleChangeMUs(evt)}/>
					</Grid>
					<Grid item xs={12} sm={12} md={12} lg={7} style={{"textAlign":"left","marginTop":"21px"}}>
						<div style={{"color":"#FF0000","fontWeight":"600","paddingTop":"0px"}}>
							{inputErrorMUs.errorText}
						</div>
					</Grid>
					<Grid item xs={12} sm={12} md={12} lg={5} style={{"textAlign":"right","marginTop":"12px"}}>
						<Button label="Salveaza" icon="pi pi-check-circle" className="p-button-sm p-button-success p-button-raised" style={{"marginRight":"6px"}} onClick={(evt) => handleButton(evt,"save_mu")} disabled={inputErrorMUs.disableSave}/>
						<Button label="Inchide" icon="pi pi-times" className="p-button-sm p-button-danger p-button-raised" onClick={(evt)=>setDialogValues({...dialogValues,openAddEditMUs:false})}/>
					</Grid>
				</Grid>
			</Dialog>
		);
	}

	const tableColTemplate = (row_data,column) => {
		if(column.field==="buttons") {
			return(
				<span>
					<Button label="Editare" icon="pi pi-pencil" tooltip="Editeaza furnizor" className="p-button-sm p-button-raised" style={{"marginRight":"3px"}} onClick={(evt) => handleButton(evt,"edit",row_data)}/>
					<Button label="Stergere" icon="pi pi-trash" tooltip="Sterge furnizor" className="p-button-sm p-button-raised p-button-danger" onClick={(evt) => confirm(evt,"delete",row_data)}/>
				</span>
			);
		}
	}

	const tableColTemplateTypes = (row_data,column) => {
		if(column.field==="buttons") {
			return(
				<span>
					<Button label="Editare" icon="pi pi-pencil" tooltip="Editeaza furnizor" className="p-button-sm p-button-raised" style={{"marginRight":"3px"}} onClick={(evt) => handleButton(evt,"edit_type",row_data)}/>
				</span>
			);
		}
	}

	const tableColTemplateMUs = (row_data,column) => {
		if(column.field==="buttons") {
			return(
				<span>
					<Button label="Editare" icon="pi pi-pencil" tooltip="Editeaza furnizor" className="p-button-sm p-button-raised" style={{"marginRight":"3px"}} onClick={(evt) => handleButton(evt,"edit_mu",row_data)}/>
				</span>
			);
		}
	}

	const confirm = (evt,what,elementData) => {
		if((what==="delete")||(what==="delete_type")||(what==="delete_mu")) {
			confirmDialog({
				message: "Sigur doriti stergerea?",
				header: "Confirmare stergere",
				icon: "pi pi-exclamation-triangle",
				accept: () => handleButton(evt,what,elementData),
				reject: () => null,
			});
		}
	}

	if(dataOk) {
		return(
			<BlockUI blocked={blockScreen} fullScreen>
				<div>
					<Grid container spacing={1} style={{}}>
						<Grid item xs={12} sm={4} md={4} lg={3} xl={3} className="field padding-med">
							<InputText name="filter_products" id="filter_products" style={{"width":"100%"}} value={inputValues.filter_providers} placeholder="Cauta produs..." onChange={(evt) => handleChange(evt)}/>							
						</Grid>						
						<Grid item xs={12} sm={4} md={4} lg={6} xl={6} className="field padding-med text-left">
							<h6 style={{"marginTop":"9px","color":"#000000"}}>{productsList.length} {(((productsList.length>1)||(productsList.length===0))?" inregistrari gasite.":" inregistrare gasita.")}</h6>
						</Grid>						
						<Grid item xs={12} sm={4} md={4} lg={3} xl={3} className="field padding-med text-right">
							<Button label="Adauga produs nou" icon="pi pi-plus-circle" className="p-button-sm p-button-primary p-button-raised" style={{}} onClick={(evt) => {handleButton(evt,"add")}}/>
						</Grid>						
					</Grid>
					<Box sx={{ display: { xs: "none", sm: "none", md: "block", lg: "block", xl: "block" } }}>
						<div className="card">
							<DataTable
								value={productsList}
								scrollable
								scrollHeight="60vh"
								style={{"minHeight":"63vh"}}
								scrollDirection="both"
								stripedRows
								resizableColumns
								columnResizeMode="fit"
								responsiveLayout="stack"
								paginator rows={10}
								stateStorage="local" stateKey="dt-state-products"
								emptyMessage="Nu exista inregistrari"
							>
								<Column field="name" header="Nume" style={{"flexGrow":"1","flexBasis":"180px"}} sortable></Column>
								<Column field="code" header="Cod" style={{"flexGrow":"1","flexBasis":"20px"}} sortable></Column>
								<Column field="product_type" header="Tip produs" style={{"flexGrow":"1","flexBasis":"90px"}} sortable></Column>
								<Column field="product_mu" header="U.M." style={{"flexGrow":"1","flexBasis":"20px"}} sortable></Column>
								<Column field="reg_date_parsed" header="Data introducerii" style={{"flexGrow":"1","flexBasis":"30px"}} sortable></Column>
								<Column field="buttons" header="" style={{"flexGrow":"0","flexBasis":"195px"}} body={tableColTemplate}></Column>
							</DataTable>
						</div>
					</Box>
					<Box sx={{ display: { xs: "block", sm: "block", md: "none", lg: "none", xl: "none" } }}>

					</Box>
				</div>
				<ConfirmDialog />
				{messageText && <Message text={messageText} closeHandler={()=>setMessageText(null)}/>}
				{dialogValues.openAddEdit && addEditDialog()}
				{dialogValues.openListTypes && listTypesDialog()}
				{dialogValues.openListMUs && listMUsDialog()}
				{dialogValues.openAddEditTypes && addEditTypesDialog()}
				{dialogValues.openAddEditMUs && addEditMUsDialog()}
            </BlockUI>
		);
	}else{
		return(
			<React.Fragment>
				<LinearProgress />
				{messageText && <Message text={messageText} closeHandler={()=>setMessageText(null)}/>}
			</React.Fragment>
		);		
	}
};

export default Products;


